import React from 'react';
import { Icon } from '../Icon';
import { IconWrapper } from './elements';
export const ChipIcon = ({
  size,
  side,
  src
}) => /*#__PURE__*/React.createElement(IconWrapper, {
  $iconSide: side
}, /*#__PURE__*/React.createElement(Icon.Compat, {
  fill: "currentColor",
  src: src,
  size: size === 'small' ? '18px' : '20px'
}));